<template>
	<div class="gradient">
		<div class="legend">
			<div class="l">
				N0<sub>2</sub>
			</div>

			<div class="datas">
				<div class="data" v-for="g of gradient" v-bind:key="g.value">{{ g.value }}</div>
			</div>


		</div>

		<div class="representation">
			<div class="l">
				(µg/m<sup>3</sup>)
			</div>
			<div class="gradient-colors">
				<div class="bg" :style="{background: colors}"></div>
			</div>
		</div>
  	</div>
</template>

<script>


export default {
	name: 'GradientControl',
	props: {
		gradient: {
			type: Array,
			default: function() {
				return [
					{color: '#f00', value: 0},
					{color: '#ff0', value: 20},
					{color: '#0f0', value: 40},
					{color: '#0ff', value: 60},
					{color: '#00f', value: 80},
				];
			}
		},
	},
	computed: {
    	colors: function () {
			let i = 0;
    		return 'linear-gradient(to right, ' + this.gradient.map(function(data) {
				let color = data.color;
				let r = color + " " + i + "%";
				i += 20;
				return r;
			}).join(',') + ')';
    	}
	},
}
</script>


<style scoped lang="scss">

.gradient {
	@include base-box() {
		background-color: #fff;
		padding: 4px 6px 4px 4px;
		display: flex;
		font-size: .6rem;
		flex-direction: column;
	}
}


.representation,
.legend {
	display: flex;
	justify-content: space-between;

	> * {
		flex-shrink: 0;
		flex-grow: 0;
		flex-basis: auto;
	}
}

.l {
	width: 40px;
}

.datas,
.gradient-colors {
	width: 110px;
}

.datas {
	display: flex;
	justify-content: space-between;

}


.gradient-colors {
	padding: 2px .8em 0 .3em;
}

.bg {
height: 8px;
}

</style>
